// import axios from "axios";
import React, { Component } from 'react';
import { post, get, getFreshToken } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
import '../adminDash.css';
import urls from '../../custom_libraries/urls';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import { Link } from 'react-router-dom';
import { Button} from '@mui/material';
import passwordEye from '../../assets/icons8-eye-64.png';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class AddUser extends Component {

  constructor(props) {
    super(props);
    this.state = {
      matches: [],
      content: '',

      user_type: 'TechnicianUser',
      user_name: '',
      tech_email: '',
      tech_password: '',
      conf_tech_pass: '',
      first_name: '',
      last_name: '',
      mob_num: '',
      dealer_email: '',
      dealer_passcode: '',
      warning:false,
      warning1:false,
      warning2:false,
      warning3:false,
      warning4:false,
      warning5:false,
      Success:false,
      error:false,
      warning_email:false,
      responseMessage:'',
      passwordShown:false,
      confPasswordShown:false,
      open_progress_bar: false,

    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    this.setState({ dealer_email : localStorage.getItem(globalVariables.USER_EMAIL)});
    // this.validateSignedIn();
    this.getDealerInfo();
  }

  validateSignedIn = async () => {
      try {
        let is_fresh_token = await getFreshToken();
        console.log("Fresh Token:", is_fresh_token);
    
        if (!is_fresh_token) {
          console.log("Navigating to login...");
          this.props.navigate("/");
          return;
        }
      } catch (error) {
        console.error("Error in validateSignedIn:", error);
      }
    }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.warning !== prevState.warning ||
        this.state.warning2 !== prevState.warning2 ||
        this.state.warning1 !== prevState.warning1 ||
        this.state.warning3 !== prevState.warning3 ||
        this.state.warning4 !== prevState.warning4 ||
        this.state.warning5 !== prevState.warning5 ||
        this.state.Success !== prevState.Success ||
        this.state.error !== prevState.error ||
        this.state.warning_email !== prevState.warning_email 
    ) {
        if (
            this.state.warning ||
            this.state.error ||
            this.state.warning1 ||
            this.state.warning2 ||
            this.state.warning3 ||
            this.state.warning4 ||
            this.state.warning5 ||
            this.state.Success ||
            this.state.warning_email
        ) {
            setTimeout(() => {
                this.setState({
                    warning: false,
                    error: false,
                    warning1: false,
                    warning2: false,
                    warning3: false,
                    warning4: false,
                    warning5: false,
                    Success: false,
                    warning_email: false,
                });
            }, 2000); // 1 second
        }
    }
}


  // validateSignedIn = async () => {
  //   let is_fresh_token = await getFreshToken()
  //   if (!is_fresh_token) {
  //     //this.props.history.replace("/sign_in");
  //     alert("Your session has expired, please login again!!");
  //     window.location.replace('/login')
  //     return
  //   }
  // }


  jsonData = () => {
    // this.setState({ dealer_email: localStorage.getItem(globalVariables.USER_EMAIL) });
    console.log("dealer_email in jsonData---------->", this.state.dealer_email);
    let data = {

      "user_type": 'CustomerUser',
      "username": this.state.user_name,
      "email": this.state.tech_email,
      "password1": this.state.tech_password,
      "password2": this.state.conf_tech_pass,
      "first_name": this.state.first_name,
      "last_name": this.state.last_name,
      "admin_email": this.state.dealer_email, //hardcoded data as of now
      "admin_passcode": this.state.dealer_passcode,  //hardcoded data as of now
      "is_staff": 0,
      "is_verified": false,
      "phoneno": this.state.mob_num

    }
    console.log("-----JSON DATA -------->", data)
    return JSON.stringify(data)
  }

  insertTechRegistrationInfo = async () => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    // let dealer_email = localStorage.getItem(globalVariables.DEALER_EMAIL)
    console.log("----------access_tocken in insertTechRegistrationInfo----------", access_tocken)
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_tocken}`
    }

    let post_data = this.jsonData()

    console.log("post_data in insertCreateTicketInfo---------->", post_data)

    // Parse the JSON string into an object
    let postDataObj = JSON.parse(post_data);

    for (const key in postDataObj) {
      if (postDataObj[key] === null || postDataObj[key] === undefined || postDataObj[key] === "") {
        // alert("Please fill in all the required fields.");
        this.setState({warning:true})
        return;
      }
    }
    // let techName = this.state.user_name
    // if (techName.length > 15 ) {
    //   console.log("techname length ---->", techName.length);
    //   alert("User name is too long, enter maximun 15 characters");
    //   return
    //  }  
    try {
      this.startLoading();
      let response= await post(urls.REGISTER, post_data, headers)
      let password = this.state.tech_password

      console.log("============= successful insert registration info =======", response);
      this.stopLoading();

        if (response && response.email) {
          // Validation error for invalid email 
          // alert(`Error: ${response.email.join(", ")}`);
          this.setState({warning4:true})
        } else if (response && response.detail) {
            // Successful registration
            // alert(`Registration successful!: ${response.detail}`);
            this.setState({Success:true})
            setTimeout(() => {
              window.location.reload();
            }, 2500); // 1 seconds delay
        }else if (response && response.password1) {
          // password is short
          // alert(`Error: ${response.password1.join(", ")}`);
          this.setState({warning2:true})
        }else if (response && response.non_field_errors?.includes("The two password fields didn't match.")) {
          //passward fields didn't match
          // alert(`Error: ${response.non_field_errors.join(", ")}`);
          this.setState({warning3:true})
        }else if (response && response.non_field_errors?.includes("The password is too similar to the username.")) {
          //passward fields didn't match
          // alert(`Error: ${response.non_field_errors.join(", ")}`);
          this.setState({Success:true})
            setTimeout(() => {
              window.location.reload();
            }, 1000); // 1 seconds delay
        }
        else if (response && response.key) {
          //if response returns the key
          this.setState({Success:true})
            setTimeout(() => {
              window.location.reload();
            }, 1000); // 1 seconds delay
        }
        else if (response[0] === 'Wrong Admin Passcode.') {
          // wrong admin passcode 
          // alert(`Error: Wrong Admin Passcode.`);
          this.setState({warning5:true})
        }else if (response && response.username) {
          // username already exist
          this.setState({warning1:true})
          // alert(`Error: ${response.username.join(", ")}`);
        }else if (response && response.email?.includes("Enter a valid email address.")) {
          // username already exist
          this.setState({warning_email:true})
          // alert(`Error: ${response.username.join(", ")}`);
        }
        else {
            // Other errors
            this.setState({error:true})
        }
      } catch (error) {
        this.setState({error:true})
        console.error("Error in Technician Registration:", error);
      }
  }

  getDealerInfo = async () => {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
    let dealer_uuid = localStorage.getItem(globalVariables.USER_ID)
    console.log("----------access_tocken in employee list----------", access_tocken)
    let headers = {
      // 'content-type': 'application/json'
      'content-Type': 'application/json; charset=UTF-8',
      'Authorization': `Bearer ${access_tocken}`,
    }
    let response = await get(`${urls.BASE_URL}/api/users/dealer_user/${dealer_uuid}/`, headers)
    console.log("-----------------getDealerInfo-----------------", response);
    this.setState({ dealer_email: response.dealer_email });
    console.log("----------dealer_email----------", this.state.dealer_email);
  }

  togglePasswordVisiblity = () => {
    this.setState(prevState => ({
      passwordShown: !prevState.passwordShown
    }));
    };

  toggleConfirmPasswordVisiblity = () => {
    this.setState(prevState => ({
      confPasswordShown: !prevState.confPasswordShown
    }));
    };

  startLoading = () => {
    console.log("startloading")

    this.setState({ open_progress_bar: true })
  }
  
  stopLoading = () => {
      this.setState({ open_progress_bar: false })
  }

  render() {
    // let admin_email = localStorage.getItem(globalVariables.USER_EMAIL);
    const{warning, warning1,warning2,warning3,warning4,Success,error, warning5, passwordShown, confPasswordShown, warning_email}=this.state

    return (
      <div>
      <>
        <div className="bordered-div" style={{ display: 'flex', flexDirection: 'column', marginLeft: '5%' }} >
                          { warning ? (<Alert severity="warning" style={{ marginLeft:'7.5%', width: "480px" }}>Please fill in all the required fields!</Alert>
                            ) :warning1 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>User name or email already exit! Verify.</Alert>
                            ) :warning2 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>password is too short! enter minimum 8 characters.</Alert>
                            ) :warning3 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>The two password fields didn't match!</Alert>
                            ) :warning4 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Enter a valid email address!</Alert>
                            ) :warning5 ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Wrong Admin Passcode.!</Alert>
                            ) :warning_email ? (
                              <Alert severity="warning" style={{ marginLeft:'7%', width: "480px" }}>Enter a valid email address!</Alert>
                            ):error ? (
                                <Alert severity="error" style={{ marginLeft:'7%', width: "480px" }}>Server Error! New user was not registered!</Alert>
                            ) :Success ? (
                                <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" style={{ marginLeft:'7%', width: "480px" }}>
                                    "Great! The new user is now registered."
                                </Alert>
                            ) : null}
          <div className='form-group'>
            <label htmlFor="user_name">User name <span style={{ color: 'red', fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
            <input
              type="text"
              id="user_name"
              name="user_name"
              required
              style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
              // placeholder=" fill upto 32 letters only (including spaces)"
              value={this.state.user_name}
              onChange={(evt) => this.setState({ user_name: evt.target.value })}
            />
          </div>
          
          <div className='form-group'>
            <label htmlFor="tech_email"> Email <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
              value={this.state.tech_email}
              onChange={(evt) => this.setState({ tech_email: evt.target.value })}
            />
          </div>
          
          <div className='form-group'>
            <label htmlFor="tech_password" > Password <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
            <div style={{ position: "relative", display: "inline-block", width: "350px" }}>
              <input
                type={passwordShown ? "text" : "password"}
                id="password"
                name="password"
                required
                style={{ width: '100%', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

                value={this.state.tech_password}
                onChange={(evt) => this.setState({ tech_password: evt.target.value })}
              />
              <span
                style={{
                  position: "absolute",
                  right: "1px",
                  top: "55%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                {/* {showPassword ? <EyeOff size={16} /> : <Eye size={16} />} */}
                <img onClick={this.togglePasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

              </span>
            </div>
          </div>
          
          <div className='form-group'>
            <label htmlFor="conf_tech_pass" > Confirm password <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
            <div style={{ position: "relative", display: "inline-block", width: "350px" }}>
            <input
              type={confPasswordShown ? "text" : "password"}
              id="conf_tech_pass"
              name="conf_tech_pass"
              required
              style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

              value={this.state.conf_tech_pass}
              onChange={(evt) => this.setState({ conf_tech_pass: evt.target.value })}
            />
            <span
                style={{
                  position: "absolute",
                  right: "1px",
                  top: "55%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <img onClick={this.toggleConfirmPasswordVisiblity} src={passwordEye} alt="password-eye" width='25' height='25' />

              </span>
              </div>
          </div>
          
          <div className='form-group'>
            <label htmlFor="first_name"> First name <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
            <input
              type="text"
              id="first_name"
              name="first_name"
              required
              style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

              value={this.state.first_name}
              onChange={(evt) => this.setState({ first_name: evt.target.value })}
            />
          </div>
          
          <div className='form-group'>
            <label htmlFor="last_name" > Last name <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
            <input
              type="text"
              id="last_name"
              name="last_name"
              required
              style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}

              value={this.state.last_name}
              onChange={(evt) => this.setState({ last_name: evt.target.value })}
            />
          </div>
          
          <div className='form-group'>
            <label htmlFor="mob_num" > Mobile no. <span style={{ color: 'red', fontFamily: "Arial, sans-serif" }}>*</span> : &nbsp;</label>
            <div style={{display:'flex', flexDirection:'column'}}>
            <input
              type="tel"
              id="mob_num"
              name="mob_num"
              required
              style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
              value={this.state.mob_num}
              // onChange={(evt) => this.setState({ mob_num: evt.target.value })}
              onChange={(evt) => {
                const value = evt.target.value.replace(/\D/g, ""); // Only allow numbers
                if (value.length <= 10) {
                  this.setState({ mob_num: value });
                }
              }}
            />
            {this.state.mob_num.length > 0 && this.state.mob_num.length !== 10 && (
              <p style={{ color: 'red', fontSize:'14px' }}>Mobile number must be exactly 10 digits</p>
            )}
            </div>
          </div>
         
               <div className='form-group'>
                  <label htmlFor="dealer_email" > Admin email <span style={{color:'red', fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
                  <input
                      type="email"
                      id="dealer_email"
                      name="dealer_email"
                      required
                      style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
                      readOnly
                      value={this.state.dealer_email}
                    />
               </div>
               
               <div className='form-group'>
                  <label htmlFor="dealer_passcode" > Admin passcode <span style={{color:'red',  fontFamily: "Arial, sans-serif"}}>*</span> : &nbsp;</label>
                  <input
                      type="text"
                      id="dealer_passcode"
                      name="dealer_passcode"
                      required
                      style={{ width: '350px', height: '0.6cm', fontFamily: "Arial, sans-serif" }}
                      
                      value={this.state.dealer_passcode}
                      onChange={(evt) => this.setState({ dealer_passcode: evt.target.value })}
                    />
               </div>
               
        </div>

        <div style={{ width: '130px', height: '0.5cm', marginLeft:'170px', marginTop: '8px', marginBottom: '100px' }}>
          <Button id="rowsPerPageButton"
            onClick={this.insertTechRegistrationInfo}
          > Add User</Button>
        </div>

        {/* <div id="copyright-footer">
          <p style={{ fontSize: '12px' }}>
            <em>&copy; 2024 Neudeep Technologies. All rights reserved.</em>
          </p>
        </div> */}
        </>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar}>
          <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
          </div>
        </Backdrop>
      </div>



    );
  }
}


export default AddUser;